import React,{useState,useEffect,useContext} from 'react'
import {Alert,Row, Col,Form,Container,  Button, Image} from "react-bootstrap"
import { InputGroup, InputGroupAddon,  InputGroupText, Input } from 'reactstrap';
import illus from "../CustomerPanel/UserProfile/Profile.png"
import { makeStyles } from '@material-ui/core'
import { Paper, TextField, FormGroup, FormControl, NativeSelect, Select, InputLabel, Grid, Checkbox, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Radio from '@material-ui/core/Radio';
import axios from "axios"
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { keys } from '@material-ui/core/styles/createBreakpoints';
import {Link,Redirect} from "react-router-dom"
import {UserContext} from "../CustomerPanel/Context/UserContext"
import {ToastContainer,toast} from "react-toastify"
import { Otp } from 'react-otp-timer';
import "../App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '../signup.css'
import "./common.css"
import ReadyToShop from './ReadyToShopNewUser';
import SignUpDisplay from './SignUpDisplay'
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton'
import {useRef} from 'react'
import { base_url } from '../globalConstants';
import OtpInput from 'react-otp-input';


import Cookies from 'universal-cookie';


const cancel={
    color:"darkblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    borderRadius:"25px",
    border:"none",
    float:"right"
  }

  const buttonstyle={
    color:"darkblue",
    backgroundColor:"skyblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    textAlign: "center",
    textDecoration: "none",
    borderRadius:"25px",
    border: "3px solid",
    float:"right"
  }

const mystyle = {
    color: "white",
    backgroundColor: "#FF7F50",
    fontFamily: "Arial",
    borderRadius:"12px"
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    paper: {
      // padding: theme.spacing(2),
      padding: '30px',
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    formControl: {
      // margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));




export default function SignUp(props) {
  const cookies = new Cookies();
  console.log( 'languahe--getsinup_es',cookies.get('language'))
  const CHARACTER_LIMIT = 6;
  const classes = useStyles();
  const [errorText2, setErrorText2] = useState(' ');
  const [errorNotVerified, setErrorNotVerified] = useState('')
  const [numberNotVerified, setNumberNotVerified] = useState('')
  const [numberVerified, setNumberVerified] = useState('')
  const [errorConfirmPassword, setErrorConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [termscheck, settermscheckbox] = useState(true);
  const [open2, setOpen2] = useState(false);
  const [isNumberVerified,  setIsNumberVerified] = useState(false)
  const [signUpDisplay, setSignUpDisplay] = useState(<SignUp/>)

  const toggle2 = () => setOpen2(!open2);

  //TEMP start
  const [state1, setState1] = React.useState({
    age: '',
    name: 'hai',
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState1({
      ...state1,
      [name]: event.target.value,
    });
  };
  //TEMP end

  const context = useContext(UserContext);
  const EId=useContext(UserContext);
    const GreenRadio = withStyles({
        root: {
          color: green[400],
          '&$checked': {
            color: green[600],
          },
        },
        checked: {},
      })((props) => <Radio color="default" {...props} />);

      const [modal, setModal] = useState(false);
      const [nestedModal, setNestedModal] = useState(false);
      const [closeAll, setCloseAll] = useState(false);
    
     const toggle = () => setModal(!modal);
      const toggleNested = () => {
        setNestedModal(!nestedModal);
        setCloseAll(false);
      }
      const toggleAll = () => {
        setNestedModal(!nestedModal);
        setCloseAll(true);
      }
    
     
      
      const mountedRef = useRef(true)
      const [selectedValue, setSelectedValue] = React.useState('b');

      const [Title,setTitle]=useState('MR.');
     
      const[firstName,setFirstName]=useState('');
      const[lastName,setLastName]=useState('');
      const[Name,setName]=useState('');
      const[Address2,setAddress2]=useState('');
      const [Address,setAddress]=useState('');
      const [City,setCity]=useState('');
      const [Zipcode,setZipcode]=useState('');
      const[Phone,setPhone]=useState('');
      const [Email,setEmail]=useState('');
      const[Country,setCountry]=useState('');
      const [Details,setDetails]=useState([]);
      const [State,setState]=useState([]);
      const [estate,setestate]=useState('')
      const [Nation,setNation]=useState('')
      const [msg,setmsg]=useState('')
      const [Ezz,setEzz]=useState('');
      const [Password, setPassword]=useState('');
      const [Created,setCreated]=useState(false);
      const [TempPassword,setTempPassword]=useState(null);
      const [ReTypePassword,setRetypePassword]=useState('');

      const [modalShow, setModalShow] = React.useState(false);

      const [TeleCode,setTeleCode]=useState('');

      const[ShippingAddress1, setShippingAddress1]=useState('');
      const[ShippingZipCode,setShippingZipCode]=useState('');
      const[ShippingPhone,setShippingPhone]=useState('');
      const [ShippingCountry,setShippingCountry]=useState('');
      const[ShippingStates,setShippingState]=useState([]);
      const [ShippingCity,setShippingCity]=useState('');
      const [ShippingNation,setShippingNation]=useState('')
      const [FixShippingState,setFixShippingState]=useState('');
      const [TempState,setTempState]=useState([]);

      const [ShippingStateFinal,setShippingStateFinal]=useState('')

      const [ShippingAddress2,setShippingAddress2]=useState('')
      const[PassMatch,setPassMatch]=useState(false);

      const [CountryCode,setCountryCode]=useState('');
      const [Verified,setVerified]=useState(false);
      const [OTP,setOTP]=useState('');

      const [ShippingDistrict,setShippingDistrict]=useState('');

      const[TelePhoneNumber,setTelePhoneNumber]=useState(TeleCode+Phone);

      const [StateCode,setStateCode]=useState({});

      const [PhoneLength,setPhoneLength]=useState('');
      const [passwordVisibilityDetails,setPasswordVisibilityDetails] = useState({icon:false,property:false})
      const [passwordConfirmVisibilityDetails,setpasswordConfirmVisibilityDetails] = useState({icon:false,property:false})

      const handleVisibility = () =>{
       setPasswordVisibilityDetails({icon:!passwordVisibilityDetails.icon,property:!passwordVisibilityDetails.property})
      };

      const handleConfirmVisibility = ()=>{
        setpasswordConfirmVisibilityDetails({icon:!passwordConfirmVisibilityDetails.icon,property:!passwordConfirmVisibilityDetails.property})
      }


        const fetchcountries=async e=>{
            const {data}=await axios.get(base_url + 'country_state_details/')
            console.log(data)
            setDetails(data);
            
        }

        useEffect(()=>{
          fetchcountries();
        },[])


     
  /* const handleChangeTitle=(event)=>{
      setTitle(event.target.value)
      console.log(event.target.value)
  } */
  const handleChangeFirstName=(event)=>{
    setErrorMessage("")
    setFirstName(event.target.value)
    // if(Name.length===0){

    // }
  }
  const handleChangeLastName=(event)=>{
    setErrorMessage("") 
    setLastName(event.target.value)
  }
 
  const handleChangeZipcode=(event)=>{
    setZipcode(event.target.value)
  }
  const handleChangeAddress=(event)=>{
    setAddress(event.target.value)
  }
  const handleChangeAddress2=(event)=>{
    setAddress2(event.target.value)
  }
  const handleChangeCity=(event)=>{
    setCity(event.target.value);
  }

  const handleChangeCountry=(event)=>{
  setCountry(event.target.value);
  document.getElementById('phoneNumber').value = ''

    Details.map(keys=>{
      
      if(keys.name===event.target.value){
        setState(keys.states);
       setCountryCode(keys.telecode);
      setPhoneLength(keys.tele_length);
       console.log(`Telecode Is ${keys.telecode}`)
       setNation(keys.country_id);
        console.log(keys.states)
        setTeleCode(keys.telecode);
        console.log(keys.telecode)
      }
    })
  }

  var len=PhoneLength;
  const handleChangePhone=(event)=>{
   // console.log(event.length, 'length of event is');
  //  setErrorNotVerified("")
   setErrorMessage("")
   setPhone(event.target.value);

}
    
  
  const handleChangeEmail=(event)=>{
    setErrorMessage("")
    setEmail(event.target.value)
  
  }
  const handleChangeState=(event)=>{
    if(selectedValue==='a'){
      
      // console.log(event.target.value[0][0])
      // console.log(event.target.value)
      setFixShippingState(event.target.value[0][0]);
      State.map(key=>{
        if(key.state_name===event.target.value){
          setestate(key.state_id);
          setShippingStateFinal(key.state_name);
          setShippingDistrict(key.state_name);
        }
      })
    }else{
      
      // console.log(event.target.value[0])
      // console.log(event.target.value[0][0])

    State.map(key=>{
      if(key.state_name===event.target.value){
        setestate(key.state_id);
      }
    })



     
    }
  
    
   
    // console.log(`state- ${event.target.value[0][0]}`)
  }

  const handlePasswordChange=(event)=>{

      setPassword(event.target.value);
  }


  const handleReTypePasswordChange=(event)=>{
    if(Password===event.target.value){
      setPassMatch(true);
      setErrorConfirmPassword("")
    }else{
      setPassMatch(false);
        setErrorConfirmPassword("La contraseña no es la misma")
    }
  }

  const handleChangeRadio = (event) => {
    setSelectedValue(event.target.value);

    if(event.target.value==='a'){
      setShippingAddress1(Address);
      setShippingZipCode(Zipcode);
      setShippingPhone(Phone)
      setShippingCity(City);
      setShippingCountry(Country);
      
      setShippingAddress2(Address2)
      
    }else{
      setShippingAddress1('');
      setShippingZipCode('');
      setShippingPhone('')
      setShippingCity('');
      setShippingCountry('');
      setFixShippingState('');
      setShippingAddress2('');
    }

  };

  const handleChangeShippingAddress1=(event)=>{
    setShippingAddress1(event.target.value);
  }
  const handleChangeShippingAddress2=(event)=>{
    setShippingAddress2(event.target.value);
  }


  const handleChangeShippingZipCode=(event)=>{
    setShippingZipCode(event.target.value);
  }
  const handleChangeShippingPhone=(event)=>{
    setShippingPhone(event.target.value);
  }
  const handleChangeShippingCountry=(event)=>{
    setShippingCountry(event.target.value);

    (Details.map(keys=>{
      if(keys.name===event.target.value){
        setShippingState(keys.states);
        setShippingNation(keys.country_id);
      }
    }))
  }
  const handleChangeShippingCity=(event)=>{
    setShippingCity(event.target.value);
  }

  const handleChangeFixShippingState=(event)=>{
    setFixShippingState(event.target.value);
    console.log(`Shipping State goesbhere ${event.target.value[0]}`)
  }

  const handleOTPchange=(event)=>{
    setErrorMessage("")
    setOTP(event);
  }
 
  const [validated, setValidated] = useState(false);

 

  


  const handleSubmit= async e=>{
  // const handleSubmit= ()=>{

    // setCreated(true);
    // changeCurrentDisplay()


//-----FRON HERE
    e.preventDefault();

    setNumberVerified("");
    if(!PassMatch){
      setErrorMessage("Contraseña no coincidente")
      // setErrorText2("Password not matched")
      return "password didnt match"
    }
  
    if(!Verified){
      setErrorMessage('número telefonico no esta verificado')
      // setErrorNotVerified('Mobile Number not Verified!')
      // toast.warn("Phone Number Not Validated!!");
    return 
    } 

    if(Email.length === 0 || firstName.length === 0 || lastName.length === 0 ){
      setErrorMessage('Detalles faltantes o incorrectos')
      return
    }

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();

    
      
    }

    setValidated(true);

  /*const formdata=new FormData();
  formdata.append('title',Title);
  formdata.append('name',Name);
  formdata.append('address',Address);
  formdata.append('city',City);
  formdata.append('zipcode',Zipcode);
  formdata.append('phone_number',Phone);
  formdata.append('email',Email);
  formdata.append('country',Country);
*/

const formdata={
  name: firstName+" "+lastName ,
  phone_number: Phone,
  email: Email,
  country: Nation,
}

  console.log(formdata);
  
   await axios({
    method: 'post',
    url: base_url+'customers/',
    data:formdata,
    headers: {'Content-Type': 'application/json' }
    })
    .then(function (response) {
        //handle success
        console.log(response);
        console.log('success');
       var alert =  <Alert  variant="success">
        Success fully created
        {console.log(Password)}
      </Alert>
        setmsg(alert)
        const {data}=response;
        const Id=data.ezz_id;
        console.log(`Ezz ID created is ${Id}`);
        setEzz(Id);
        localStorage.setItem("ezzyid", Id)
        
        

        const newdata={
          email:Email,
          password: Password,
          security_question:"First Dog?",
          security_answer:"romie",
          is_customer: "True"
        }

         axios({
          method:'post',
          url:base_url+'create_user/',
          data: newdata,
          headers: {'Content-Type': 'application/json' }
        }).then(function(response){
          console.log(response);
          console.log('django success');

          // email verificaiton
          const emaildata={
        
            type : "account_activation", 
            ezz_id :Id,
            password: Password
          }
          axios({
            method:'post',
            url:base_url+'send_email/',
            data: emaildata,
            headers: {'Content-Type': 'application/json' }
          }).then(function(email){
            console.log(email);
            console.log('email sent success');
            

            setCreated(true);
            if (!mountedRef.current) return null;

            // setSignUpDisplay(<ReadyToShop/>)

            // changeCurrentDisplay()

            // toast.success('Sign Up SUccesfully!')
            // toast.success('Please Login to continue');

          }).catch(function(email){
            console.log(email)
            console.log('email sending failed')
          })
           
        }).catch(function(response){
          console.log(response)
          console.log('inner api failed')
        })
    
    })
    .catch(function (response) {
        //handle error

        setErrorMessage(response.response.data.email?"el Email ya existe":'Detalles faltantes o incorrectos');
        // setErrorText2(response.response.data.email?"Email already exist":'Missing or Incorrect Details');
        console.log('error')     
    });
//-----TILL HERE


   /* const handleOtpSubmit=async e=>{
      e.preventDefault();
      const phonedata=new FormData();
      phonedata.append('MobileNumber', Phone);

   await axios({
    method: 'post',
    url: base_url+'verify_number/',
    data:phonedata,
    headers: {'Content-Type': 'application/json' }
    }).then(function(response){
      console.log("OTP success")
      console.log(response);
      
    }).catch(function(response){
      console.log('OTP failure');
      console.log(response);
    })

    } */
  }

  //RESEND OTP START

  let style = {
    otpTimer: {
      margin: '10px',
      color: 'blue',
    },
    resendBtn: {
      // backgroundColor: '#5cb85c',
      // border: '1 px solid #ccc'
      // color: 'white',
      color: '#ff5500',
      border: '1px solid #ff5500',
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: '5px 15px',

      "&:hover":{
        color: 'white',
        backgroundColor: '#ff5500',
      },
      "&:focus":{
        outline: '5px solid #ff5500'
      }
    }
  }

  const resendEvent = async () => {

    const ResendotpData = new FormData();
    ResendotpData.append('MobileNumber', Phone);
    ResendotpData.append('tele', TeleCode);
    ResendotpData.append('type', "verify");
    ResendotpData.append('email', Email);

    axios(
      {
        method: 'post',
        url: base_url+'verify_number/',
        data: ResendotpData,
        headers: { 'Content-Type': 'application/json' }
      }
    )
      .then(function (response) {
        console.log(response);
        console.log('OTP sent');
        console.log('resend done')
      })
      .catch(function (response) {
        console.log(response);
        console.log('OTP sending failure');
        console.log('resend failure')

      })
  }





    return (
     

        <div >



        <UserContext.Provider value={Ezz}>
        {Created ? <Redirect to =
        {{
          // pathname: "/ReadyToShop",
          pathname: "/readytoshop",
         
          state: { ezz_id: 12321567 }
        }}
        />:<>
        {
        cookies.get('language') ==='es' ?
        <Redirect to = "/signup_es" />

          :       <Redirect to = "/signup_es" />}</>}
 

        {/* {Created ? <Redirect to="/readytoshop" ezzId = {Ezz} />:''} */}
        </UserContext.Provider>
        <Row style={{textAlign: "center", marginTop: '10px'}} >
            <Col>
            {/* <h1 ><p id="logo-container"  className="brand-logo text-center compamny_title indigo-text ">Ezzy<span className="orange-text">Ship</span></p></h1> */}
            <Image src="assets/images/group-4-copy.png" />
            </Col>

        </Row><br/>


        <Container>

          <Row>


            <Col md={{ span: 4, offset: 4 }}>

            <Paper className="justify-content-md-center" className={classes.paper} elevation={5} style={{ alignContent:"center" }}  >
                <h3 className='mainHeading' >Crear Cuenta</h3>
                <p className='secondaryHeading' >
                Ingresar abajo la información de cuenta y paísw <br/>
                </p>


                <Form noValidate validated={validated} onSubmit={handleSubmit} >

                    <Row >
                      <Col className="justify-content-md-center"  >
                        <TextField id="first_name" label="Primer Nombre" variant="filled" required onChange={handleChangeFirstName} className='textField' fullWidth />
                      </Col>
                      <Col className="justify-content-md-center"  >
                        <TextField id="last_name" label="Segundo Nombre" variant="filled" required onChange={handleChangeLastName} className='textField' fullWidth />
                      </Col>
                    </Row><br/>
                    <Row >
                      <Col className="justify-content-md-center"  >
                        <TextField id="email_id" label="Correo Electrónico" type='email' variant="filled" required onChange={handleChangeEmail} className='textField' fullWidth 
                        
                        />
                      </Col>
                    </Row><br/>
                    <Row>
                      <Col className="justify-content-md-center" >
                        <TextField id="password" label="Contraseña" variant="filled" required type={passwordVisibilityDetails.property?"text":"password"}
                          onChange={handlePasswordChange} className='textField' fullWidth 
                        helperText='Debe ser por lo menos 6 caracteres' InputProps={{ 
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                aria-label='toggle password visibility'
                                onClick={handleVisibility}
                                >
                                {passwordVisibilityDetails.icon?<Visibility/>:<VisibilityOff/>} 
                              </IconButton>
                            </InputAdornment>
                          ),
                        }} />
                      </Col>
                    </Row><br/>
                    <Row>
                      <Col className="justify-content-md-center" >
                        <TextField id="confirm_password" label="Confirmar Contraseña" variant="filled" required type={passwordConfirmVisibilityDetails.property?"text":"password"}
                          onChange={handleReTypePasswordChange} className='textField' fullWidth 
                        helperText='Debe ser por lo menos 6 caracteres' InputProps={{
                          
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                aria-label='toggle password visibility'
                                onClick={handleConfirmVisibility}
                                >
                                {passwordConfirmVisibilityDetails.icon?<Visibility/>:<VisibilityOff/>}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}/>
                        { 
                          PassMatch 
                          ? "" 
                          : <span style={{ color: "red", textAlign: "center", fontWeight: "600" }}>{errorConfirmPassword}</span>
                        }
                      </Col>
                    </Row><br/>
                    <Row>
                      <Col className="justify-content-md-center" >

                      <FormControl variant="filled" className={classes.formControl} className='textField' fullWidth>
                        <InputLabel required htmlFor="selectCountry" id='selectCountry-label' >País</InputLabel>
                        <Select required fullWidth
                          native                          
                          defaultValue="Select your Country"
                          onChange={handleChangeCountry}
                          inputProps={{
                            name: 'country',
                            id: 'selectCountry',
                          }}
                        >
                          <option aria-label="None" value="" />
                          {Details.map(key => {
                            return (
                              <option key={key.name}>{key.name}</option>
                            )
                          })}
                        </Select>
                      </FormControl>
                        
                        
                      </Col>
                    </Row><br/>
                    <Row >
                      <Col md={{ span: 4 }} className="justify-content-md-center" >
                        <FormGroup as={Col} controlid="validationCustom01">
                          <FormControl value={TeleCode} >
                            <TextField id="teleCode" label="código" value={TeleCode} variant="filled" className='textField' fullWidth disabled 
                            InputProps={{
                              readOnly: true,
                            }}/>
                          </FormControl>
                        </FormGroup>  
                      </Col>
                      <Col md={{ span: 8 }} className="justify-content-md-center" >

                        <FormGroup as={Col} controlid="validationCustom01">
                          <FormControl onChange={handleChangePhone}>
                            <TextField required id="phoneNumber" label="Numero de teléfono" type='number' variant="filled" className='textField' onChange={handleChangePhone} fullWidth />
                            {
                              Phone.length > 0 && Phone.length < PhoneLength 
                              ?  <p style={{color:'red', fontSize: 'small'}}>*ingrese {PhoneLength} número digito</p>
                              :' '
                            }
                        {/*   EXACT LENGTH BELOW::::: */}      
                          {/* {Phone.length > 10 ?  <p style={{color:'red'}}>*Please enter {PhoneLength} digit number</p>:' '}  */}
                            {/* <Button variant="Link" id="validateOTP" className=" loginlink " onClick={toggle} >
                              Validate OTP
                            </Button> */}
                          </FormControl>
                        </FormGroup>  

                        
                      </Col>
                    </Row>
                    {
                      errorMessage
                      ?<span className='errorText'><br/>{errorMessage}<br/></span>
                      :""
                    }         
                    {
                      numberVerified
                      ?<span style={{ color: 'green', fontWeight: 'bold' }}><br/>{numberVerified}</span>
                      :""
                    }      
                    {/* <span className='errorText'>{errorText2}</span> */}

                    <Row className="justify-content-md-center">
                    
                          <Checkbox
                            //checked={state.}
                            //onChange={handleChange}
                            id= 'checkTermsAndConditions'
                            name="checkedB"
                            color="primary"
                            value = {termscheck}
                            onChange = {()=> {settermscheckbox(!termscheck)}} 
                          />
                    
                    <Link to={{ pathname: "https://ezzyship-demo.netlify.app/termsandconditions.html" }} target="_blank" className="termslink" >
                      <Button variant="Link" id="termslink" className=" termslink">

                      acepto los términos y condiciones.
                      </Button>
                      
                      </Link>
                      
                      
                    </Row>                             
                    <Row>

                   
                        {/* <Button variant="Link" id="validateOTP" className=" loginlink " type="submit"  >Validate OTP</Button> */}
                        
                                            

                      <Col className="justify-content-md-center" >
                      {
                        Phone.length >= PhoneLength && Phone.length > 0
                        ?   

                        isNumberVerified
                        ?
                          <Button id="createAccount" size='lg' className="customButton1" type="submit" block   >
                                Crear una cuenta
                          </Button>
                        :
                          <Button id="getOneTimeCode" size='lg' className="customButton1"  block disabled = {termscheck} 
                          
                            // onClick={() => setModal(!modal)}
                          
                            onClick={(e) => {
                            e.preventDefault();

                            console.log(TeleCode + Phone)


                            const phonedata = new FormData();
                            phonedata.append('MobileNumber', Phone);
                            phonedata.append('tele', TeleCode);
                            phonedata.append('type', "verify");
                            phonedata.append('email', Email);

                            axios({
                              method: 'get',
                              url: base_url+`customers/?ezz_id=&ezz_id__icontains=&email__iexact=&phone_number=${Phone}`,

                            }).then(function (response) {
                              console.log(response)
                              // toast.success('no. already exists');
                              if (response.data.results.length === 0) {
                                axios({
                                  method: 'post',
                                  url: base_url+'verify_number/',
                                  data: phonedata,
                                  headers: { 'Content-Type': 'application/json' }
                                }).then(function (response) {

                                  console.log(response);
                                  setModal(!modal);


                                }).catch(function (response) {
                                  console.log('OTP failure');
                                  console.log(response);
                                })
                              } else {
                                setErrorMessage('número ya existe')
                                // setErrorNotVerified('Number already exists')
                                // toast.success('no. already exists.')
                              }
                            }).catch(function (response) {
                              console.error(response);

                            })


                          }} 

                          >

                            GET ONE TIME CODE
                              
                          </Button>

                         : 

                          <Button id="getOneTimeCode" size='lg' className="customButton1"  block disabled  >
                            GET ONE TIME CODE
                          </Button>

                        }   
                        <p className='secondaryHeading' style={{ marginTop: '10px', marginBottom: 0 }}>
                        Ya tiene una Cuenta?
                        </p>
                        <Link to="/" className="customButton2" >
                          <Button id="signIn" className="customButton2" variant="outline-primary" size='lg' block >
                          Iniciar Sesión
                          </Button>
                        </Link>
                      </Col>
                    </Row>

                </Form>
            </Paper>    

            </Col>
          </Row>

          <Modal style={{ height: '80%' }} isOpen={modal} toggle={toggle} >
          <ModalHeader>numero telefonico verificación</ModalHeader>
            {/* <ModalHeader toggle={toggle} style={{ color: "#FF4500", fontSize: "4opx" }}>
            
            </ModalHeader> */}
            <ModalBody>
            
              {/* <h4 style={{ color: "#008899", textAlign: 'center' }} >Phone Number Verification</h4>               */}
              {/* <h6 style={{ paddingTop: '8px', paddingBottom: '8px', paddingLeft: '5px', paddingRight: '5px', backgroundColor: '#F5BCBA', color: '#2B2B52', borderRadius: '10px' }}>Please enter OTP sent on your Mobile Phone: {CountryCode}-{Phone}</h6> */}
              <h6>ingresa 4 código dígitos recibió a numero telefónico: <br/> +{CountryCode}-{Phone}</h6><br/>
                  {/* <TextField id="shippingAddress2" label="Enter Code Here" variant="filled" className='textField'
                    onChange={handleOTPchange} /><br /> */}

                  {/* <InputGroup>
                <Input onChange={handleOTPchange} />
                <InputGroupAddon addonType="append">
                  <InputGroupText>OTP</InputGroupText>
                </InputGroupAddon> 
              </InputGroup> */}
                  {/* <p><br/></p> */}
                  <br />
                <Row>
                
                <Col xs={6} md lg={6}>
                  
                  <OtpInput
                    inputStyle={style={"outline":"none","border":"none",'width':"50px","height":"50px","border-bottom":"3px solid black","font-size":"20px"}}
                    minutes={1.99}      // Minutes ( Pass the no of minutes that you want count )
                    resendEvent={resendEvent} //  Resend button event you can pass your function name here
                    numInputs={4}
                    separator={<span>-</span>}
                    onChange={(event)=>{handleOTPchange(event)}}
                    value = {OTP}
                  />
                   {
                    numberNotVerified == ''
                      ? ""
                      : <span style={{ color: "red", textAlign: "center", fontWeight: "600", fontSize: 'small' }}>{numberNotVerified}</span>
                  }
                </Col>
               
                <Col xs={6} md lg={5} style={{ textAlign: 'center' }}>
                        <Otp
                          style={style}
                          minutes={1.99}      // Minutes ( Pass the no of minutes that you want count )
                          resendEvent={resendEvent} //  Resend button event you can pass your function name here
                        />
                      </Col>

              </Row><br/>
              
              <ModalFooter>
                  <Button className="customButton1" 
                  onClick={(e) => {
                    e.preventDefault();
                    console.log(TeleCode);
                    axios.get(base_url+`verify_number/?MobileNumber=${Phone}&otp=${OTP}&type=verify`)
                      .then(function (response) {
                        console.log("OTP verification success")
                        console.log(response);

                        // setNestedModal(!nestedModal);
                        // setCloseAll(false);
                        setVerified(true);
                        setNumberVerified('Number Verified Successfully')
                        setIsNumberVerified(true)
                        // setCloseAll(true);
                        // setNestedModal(!nestedModal);
                        // setCloseAll(true);
                        // toggleAll()
                        toggle()
                      })
                      .catch(function (response) {

                        console.log(response)
                        console.log(response.Status)         
                        
                        setNumberNotVerified(`código incorrecto. vuelva a intentar`)
                        
                        // if (response.status == 403) {
                        //   setNumberNotVerified('Incorrect code!! Please enter again')
                        //   // toast.warn('Wrong OTP!! Please enter again')
                        // } else {
                        //   setNumberNotVerified('Please Try Again')
                        //   // toast.warn('Please Try Again');
                        // }
                      })

                  }}
                  // onClick={toggle}
                  >
                    ACCESO
                </Button>{' '}
                  <Button id="closeOtpModal2" className="customButton2" onClick={toggle}  >
                    Carrer
                </Button>                      
              </ModalFooter>

              {/* <Modal isOpen={nestedModal} toggle={toggleNested} onClosed={closeAll ? toggle : undefined}>

                <h3 style={{ color: "#FF4500", fontSize: "4opx" }}>Phone Number Verification done successfully!!</h3>
                <ModalFooter>
                  <Button color="primary" onClick={toggleAll}>Done</Button>{' '}

                </ModalFooter>
              </Modal> */}
            </ModalBody>

          </Modal> 

        </Container>


              
        </div>
    )
}

